import React from 'react';
import { Grid, Typography } from '@mui/material';
import { getBatteryIcon } from '../../lib/utils';

function BatteryLevel({ batteryLevel }) {
  return (
    <Grid container alignItems="center" justifyContent="center" direction="row">
      <Grid item>
        {getBatteryIcon(batteryLevel)}
      </Grid>
      <Grid item>
        {batteryLevel
        && (
        <Typography variant="subtitle2">
          {`${batteryLevel}%`}
        </Typography>
        )}
      </Grid>
    </Grid>
  );
}

export default BatteryLevel;
